import { get, post } from "../AxiosConfig";

const URI = "/company";

const listCompany = (payload) => {
  const URL = `${URI}/list-company`;
  return post(URL, payload);
};

const createCompany = (payload) => {
  const URL = `${URI}/create-company`;
  return post(URL, payload);
};

const updateCompany = (payload) => {
  const URL = `${URI}/update-company`;
  return post(URL, payload);
};

const deleteCompany = (payload) => {
  const URL = `${URI}/delete-company`;
  return post(URL, payload);
};

// ─── Module activation (פירוק מודולים פר-חברה) ───────────────────────────────
// הערה: קודי המודולים המלאים מוגדרים ב-`constants/moduleCatalog.js` (mirror של backend).
// MODULE_CODES נשמר לאחור-תאימות בלבד (קודים גסים legacy — deprecated).
export const MODULE_CODES = {
  PROFITABILITY:    'Profitability',
  INVOICES:         'Invoices',
  EXPENSES:         'Expenses',
  COST_CALCULATION: 'CostCalculation',
};

const getCompanyModules = ({ companyId, activeOnly = false }) =>
  get(`/company/modules?companyId=${companyId}&activeOnly=${activeOnly ? 1 : 0}`);

const toggleCompanyModule = (payload) =>
  post(`/company/module-toggle`, payload);

// קטלוג המודולים הסטטי (קוד, שם תצוגה, קטגוריה, isBasic) — משמש את מסך הניהול.
const getModuleCatalog = () => get(`/company/module-catalog`);

const CompanyService = {
  listCompany,
  createCompany,
  updateCompany,
  deleteCompany,
  getCompanyModules,
  toggleCompanyModule,
  getModuleCatalog,
};

export default CompanyService;
